import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { NEIGHBOR_QUOTES } from "../data/mock";

export function TownQuotes() {
  const copies = NEIGHBOR_QUOTES.length <= 4 ? 4 : 2;
  const items = Array.from({ length: copies }).flatMap(() => NEIGHBOR_QUOTES);
  return (
    <div className="relative overflow-hidden" data-testid="town-quotes-strip">
      <div className="flex w-max gap-5 town-marquee">
        {items.map((q, i) => (
          <Link
            key={i}
            to={`/blog/${q.slug}`}
            aria-hidden={i >= NEIGHBOR_QUOTES.length}
            tabIndex={i >= NEIGHBOR_QUOTES.length ? -1 : 0}
            className="w-[320px] sm:w-[380px] shrink-0 bg-[#121214] border border-white/8 hover:border-[#9D0423]/50 transition-colors p-6 flex flex-col group"
            data-testid={i < NEIGHBOR_QUOTES.length ? `town-quote-${q.slug}` : undefined}
          >
            <span className="self-start inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#E56A79] border border-[#9D0423]/40 px-2.5 py-1">
              <MapPin size={11} /> {q.town}
            </span>
            <h3 className="mt-4 font-heading font-extrabold uppercase text-white text-lg tracking-wide">{q.name}</h3>
            <p className="mt-2 text-[14px] text-neutral-400 leading-relaxed flex-1">{q.text}</p>
            <span className="mt-4 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.16em] text-neutral-500 group-hover:text-[#9D0423] transition-colors">
              Read their story <ArrowRight size={13} />
            </span>
          </Link>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-28 bg-gradient-to-r from-[#0D0D0F] to-transparent" aria-hidden="true" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-28 bg-gradient-to-l from-[#0D0D0F] to-transparent" aria-hidden="true" />
    </div>
  );
}
